<template>
  <div v-on:keyup.enter="submit">
    <v-layout
      align-start
      justify-center
      fill-height
      :class="{'py-2': $vuetify.breakpoint.xs, 'py-5': $vuetify.breakpoint.smAndUp}"
    >
      <v-flex xs12 sm6 xl4>
        <v-card class="rounded-card elevation-3">
          <v-container>
            <v-layout pt-3 pb-3 align-start justify-center>
              <img width="172" :src="'/img/logo_' + vueAppID + '.png'" />
            </v-layout>
            <v-flex xs10 offset-xs1 sm8 offset-sm2>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    prepend-icon="person"
                    class="cmr-input"
                    name="email"
                    label="Email"
                    type="email"
                    v-model="email"
                    :rules="emailRules"
                    single-line
                    required
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    required
                    class="cmr-input"
                    single-line
                    v-model="password"
                    :rules="passwordRules"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-flex>
            <v-layout align-start justify-center>
              <v-btn
                color="primary"
                id="signin"
                class="rounded-button text-none"
                :disabled="!valid"
                @click="submit"
              >
                <div v-if="!loading">Sign In</div>
                <pulse-loader v-else :loading="loading" color="#fff"></pulse-loader>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Cannot sign in</v-card-title>

        <v-card-text>{{this.error}}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "SignInForm",
  components: {
    PulseLoader
  },
  props: {
    msg: String
  },
  data() {
    return {
      vueAppID: this.$store.state.appID,
      loading: false,
      dialog: false,
      error: "",
      valid: false,
      email: "",
      password: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var error = await this.$store.dispatch("login", {
          email: this.email,
          password: this.password,
          redirect: this.$route.query.redirect
        });

        console.log(error);

        if (error != null && error == "auth_failed") {
          this.loading = false;
          this.dialog = true;
          this.error = "Incorrect Login Credentials, please try again";
        } else {
          this.loading = false;
          this.dialog = true;
          this.error = "Network failure, Please check your internet connection";
        }
      }
    },
    signup() {
      this.$router.push("/signup");
    },
    forgotPassword() {
      this.$router.push("/forgot_password");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rounded-button {
  border-radius: 8px !important;
}

#signin {
  border-radius: 12px !important;
  font-size: 18px;
  height: 48px;
  width: 120px;
}

#signup {
  border-radius: 12px !important;
  font-size: 14px;
}

.rounded-card {
  border-radius: 12px;
}
</style>
